import { render, staticRenderFns } from "./RepackModal.vue?vue&type=template&id=b2c2007c"
import script from "./RepackModal.vue?vue&type=script&lang=js"
export * from "./RepackModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports